const protocols = {
  title: "{{patientTerm}} {{treatmentPlanTerm}}",
  protocols: "Protocols",
  ApplyProtocol: "Apply protocol",
  BackToFullscriptProtocols: "Back to Fullscript protocols",
  LoadMore: "Load more",
  subtitle:
    "Make {{treatmentPlanTermPresentParticiple}} easier. Manage and create {{treatmentPlanTerm}} protocols here.",
  NewProtocol: "New protocol",
  SearchFullscriptProtocols: "Search Fullscript protocols...",
  SearchMyProtocols: "Search my protocols...",
  SearchSharedWithMeProtocols: "Search shared with me...",
  ariaProtocolActions: "View protocol actions",
  MakePrivate: "Make protocol private",
  ShareWithPatients: "Share with {{patientTermPlural}}",
  ShareWithMyPatients: "Share with my {{patientTermPlural}}",
  ShareWithAllPatients: "Share with all {{patientTermPlural}}",
  MakeProtocolPublic: "Make public",
  MakeProtocolPrivate: "Make private",
  CopyURL: "Copy URL",
  AreYouSure: "Are you sure?",
  ConfirmPublicShareDescription:
    "Changing global access will immediately affect accounts access to this global FS template",
  MakeProtocolPublicMyPatients: "Make public for my {{patientTermPlural}}",
  ShareAll: "Share all",
  New: "New",
  NoUsersFound: "No {{usersTerm}} found",
  confirmDeleteTitle: "Delete '{{ protocolName }}' protocol?",
  confirmDeleteText: "Are you sure you want to delete this protocol? This action cannot be undone.",
  SomethingWrong: "Something went wrong",
  ErrorDeletingProtocol: "There was an error deleting your protocol",
  MoreInfo: "More Info",
  ReadMoreOnOurWebsite: "Read more on our website",
  LinkCopied: "Link copied to clipboard!",
  CopyProtocolLink: "Copy protocol link",
  LastUpdated: "Last updated:",
  SharedWith: "Shared with:",
  Owner: "Owner:",
  Share: "Share",
  CopyLink: "Copy link",
  MakeCopy: "Make copy",
  You: "You",
  BackToProtocol: "Back to protocol",
  BackToProtocols: "Back to protocols",
  BlueHouse: "Blue house",
  ViewEvidence: "View evidence",
  CopyToMyProtocols: "Copy to my protocols",
  ViewProducts: "View products",
  ProtocolsHeaderSubText:
    "Make your workflow a little more flow and a lot less work with protocols. Create and save your own, or pull from the Fullscript library of evidence-based, ready-made protocols to save time when sending and {{treatmentPlanTerm}}.",
  ProtocolsHeaderSubText2:
    "Protocols can be customized for a single {{patientTerm}}, or sent to multiple or all {{patientTermPlural}} for easy one-to-many care.",
  numberStaff: "{{num}} staff",
  ViewDetails: "View details",
  CopiedFrom: "Copied from: ",
  ALL: "All",

  MY_TEMPLATES: "My protocols",

  SHARED_TEMPLATES: "Shared with me",

  IMAT_TEMPLATES: "Fullscript protocols",
  ProtocolsTitle: "Ready-made protocols",
  EvidenceBased: "30+ free, evidence-based protocols — now at your fingertips!",
  SeeFullscriptProtocols: "See Fullscript protocols",
  EmptyState: {
    NoResultMatching: 'No result matching <2>"{{searchTerm}}"</2>',
    LookingFor: "Looking for a specific protocol? <1>Send a request</1>",
  },
  ProtocolDetailsPage: {
    Overview: "Overview",
    Attachments: "Attachments",
    References: "References",
    EvidenceRating: "Evidence rating",
    SupportYourTreatmentPlan: "Support your {{treatmentPlanTerm}} with these additional resources",
    TheFollowingProtocols:
      "The following protocols were developed using only <1>{{evidenceRating}}</1>-quality evidence",
    LearnMoreAbout: "Learn more about our rating scale",
  },
  WhatAreFullscriptProtocolsModal: {
    // First page
    WhatAreFullscriptProtocols: "Created by practitioners, for practitioners",
    FullscriptMakesRecommendingEasier:
      "We make it fast and easy to {{treatmentPlanTermVerb}} supplements with integrative protocols that are rooted in research, and both clinical and industry expertise.",
    // Second page
    WhyShouldPractitionersUseThem: "Decision support that saves time",
    SaveTimeOnResearch:
      "Spend less time researching and reviewing, and more time with {{patientTermPlural}}",
    AdjustThemToMeetPatientNeeds: "Customize for individual {{patientTerm}} needs",
    ProvideGuidingAndEducationalInformation:
      "Send protocols that come with educational {{patientTerm}} handouts",
    // Third page
    GetStartedInFiveSteps: "Get started in five steps...",
    FullscriptProtocolsAreNowAvailable:
      "Fullscript protocols are now available directly in your {{treatmentPlanTermPastParticiple}} workflow!",
    BrowseTheLibrary: "Browse the library",
    SelectYourDesiredProtocol: "Select a protocol",
    CopyToYourProtocols: "Copy it to your protocols",
    CustomizeForOptimalPatientCare: "Customize, if required",
    ShareWithYourPatients: "Share it with {{patientTermPlural}}!",
  },
  shareModal: {
    descriptionSingle: {
      line1:
        "When you share with 'my {{patientTermPlural}}', only those who you add as a {{patientTerm}} and prescribe to will be able to see this protocol.",
      line2:
        "They'll be able to view the message, attachments, and purchase its recommended products. You can also generate a link that can be shared publicly, driving people — even if they're not currently a {{patientTerm}} of yours — to your dispensary where they can view and order from this protocol.",
    },
    descriptionAll:
      "They'll be able to view the message, attachments, and purchase its recommended products. You can also generate a link that can be shared publicly, driving people — even if they're not currently a {{patientTerm}} of yours — to your dispensary where they can view and order from this protocol.",

    goBack: "Go back",
  },

  moreInfoModal: {
    title: "Here's what you need to know",
    description:
      "Wellness protocols are a way for you to connect with {{patientTermPlural}} beyond appointments. Updates made to shared protocols will also update on your {{patientTermPlural}} accounts.",
  },

  prescriptionOnlyModal: {
    title: "This protocol contains prescription-only products",
    description:
      "We don't support publicly sharing protocols that contain prescription-only products. To make this protocol public, you'll need to remove or swap the restricted products first.",
    keepPrivate: "Keep private",
    editProtocol: "Edit protocol",
  },

  editPublicModal: {
    title: "This protocol is shared with {{patients}}",
    description: "Any changes you make to this protocol will be updated for your {{patients}}.",
    editProtocol: "Edit protocol",
    cancel: "Cancel",
  },

  makePrivateModal: {
    title: "Are you sure you want to make this protocol private?",
    confirmButton: "Yes, make private",
  },

  deleteModal: {
    title: "Are you sure you want to delete this protocol?",
    descriptionPublic:
      "Deleting this protocol will make it unavailable to all patients who have access. All information and attachments will be deleted.",
    descriptionPrivate: "All information and attachments will be deleted.",
    Delete: "Delete",
    Cancel: "Cancel",
    errorTitle: "Something went wrong",
    errorDescription:
      "There was an error deleting your protocol. You may want to check your network connection.",
  },

  makeCopyModal: {
    title: "Copy protocol?",
    description:
      'You are about to make a copy of {{ownerName}}\'s "{{protocolName}}" protocol. Do you wish to continue? You will be able to edit this protocol and share it with {{patientTermPlural}}.',
    cancel: "Cancel",
    makeCopy: "Make a copy",
    successToast: "Protocol successfully copied",
  },

  newFeatureModal: {
    title: "We have exciting news!",
    description:
      "You can now share protocols with all of your patients in an instant. You can choose to make them available to your entire patient list, and can also generate a link that, when shared externally, will direct people to that protocol in your dispensary. ",
  },

  patientSharingLevelLabels: {
    PrivateProtocol: "Private protocol",
    SharedWithMyPatients: "Shared with my {{patientTermPlural}}",
    SharedWithAllPatients: "Shared with all {{patientTermPlural}}",
    MyPatients: "My {{patientTermPlural}}",
    AllPatients: "All {{patientTermPlural}}",
  },

  copyLinkModal: {
    title: "You're all set!",
    descriptionAllPatients:
      "This protocol is now available to all {{patientsTerm}} in your dispensary, and will be found on their {{treatmentPlanTerm}} page. You can also use the link below to share this protocol outside of Fullscript. Anyone with this link will be able to log in or create a Fullscript account to view and purchase products from this protocol.",
    descriptionYourPatients:
      "This protocol is now available to your {{patientsTerm}} in your dispensary, and will be found on their {{treatmentPlanTerm}} page. You can also use the link below to share this protocol outside of Fullscript. Anyone with this link will be able to log in or create a Fullscript account to view and purchase products from this protocol.",
    Copy: "Copy",
  },
  // Protocols P2
  SeeWhatsNew: "See what's new!",
  AllCategories: "All categories",
  FullscriptProtocolSuccessCopy: "Protocol copied successfully to 'My protocols'. <1>View now</1>",
  FullscriptProtocolsDisclaimer:
    "The protocols in this section are curated by the Fullscript Integrative Medical Advisory Team, developed using an <1>evidence-informed approach</1>, that practitioners can use as a foundation when developing individualized treatment plans.",
  sort: {
    Sort: "Sort",
    AlphabeticalAZ: "A-Z",
    AlphabeticalZA: "Z-A",
    NewestCreated: "Last created: newest",
    OldestCreated: "Last created: oldest",
    NewestUpdated: "Last updated: newest",
    OldestUpdated: "Last updated: oldest",
  },

  footerButtons: {
    PatientPreview: "Patient preview",
    ShareWithPatients: "Share with patients",
    ResetDraft: "Reset draft",
  },

  sharingModal: {
    ShareProtocol: "Share protocol",
    summaryOfChanges: "Summary of changes",
    Note: "Note",
    emailsNote: "Only selected {{ usersTerm }} will be sent an email",
    sharedProtocolsTitle: "Sharing:",
    sharingWithTitle: "With:",
    shareButtonTitle: "Share protocol",
    Update: "Update",
    more: "more",

    NoOne: "No one",
    moreCount: "+{{count}} more",

    sharedWithAllPatients: "<0>All patients</0> in this dispensary have access to this protocol.",
    sharedWithMyPatients: "All of <1>your</1> patients have access to this protocol.",
    viewableByStaff:
      "<0>Selected staff</0> can view and make a copy. Only you can make edits to the original version.",
    Staff: "Staff",
  },

  emptyState: {
    description:
      "Protocols are a great way to practice one to many care and are a great way to keep your {{patients}} engaged. Get started today:",
    CTA: "Create my first protocol",
  },

  confirmSpecificPatientsSharing: {
    title: "Share with just specific {{patientsTerm}}?",
    descriptionAllPatients:
      "This protocol is public to every {{patientTerm}} in your dispensary. All {{patientsTerm}} except for those you have selected will lose access and the link will not work.",
    descriptionYourPatients:
      "This protocol is public to all your {{patientsTerm}}. All {{patientsTerm}} except for those you have selected will lose access to the protocol.",
    continue: "Continue",
    cancel: "Cancel",
  },
} as const;

export { protocols };
